import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { GridColumnType } from "../../../../../data/gridColumnType";

const initState = {
  projectTypeName: '',
  isActive: '',
}

export const projectTypeFormData = {
  name: "Project Type Form",
  initialState: initState,
  section: [
    {
      sectionId: 'ProjectType',
      title: "Project Type",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 mb-2",
      },
      wrappperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "projectTypeName",
          label: "Project type name",
          Field_Name: "project Type",
          fieldType: FormFieldTypes.INPUT,
          dataField: "projectTypeName",
          fieldSetting: {
            placeholder: "Please Enter Project Type",
            allowSpace: true,
            isDisable: false,
            maxLength: 50,
          },
          validation: [{type: validationTypes.REQUIRE}],
          style: {
            containerCss: "col-lg-12   col-md-12 mb-1 validation-left-0",
          },
        },  
          {
            id: "isActive",
            label: "Is Active",
            Field_Name: "isactive",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "isActive",
            fieldSetting: {
              allowSpace: true,
            },
            // validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "col-lg-6 col-md-6 mt-3 double-label-sec checkbox-style",
            },
          },
      ]
    }
  ]
}

export const projectTypeGridConfig = {
  columns: [
    {
      name: "Project Type",
      fieldName: "projectTypeName",
      allowShort: false,
      colStyle: {
        width: "43%",
        textAlign: "center",
      },
    },
    {
        name: "Status",
        colType: GridColumnType.CHECKBOX,
        fieldName: "isActive",
        allowShort: false,
        colStyle: {
          width: "43%",
          textAlign: "center",
        },
      },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      colStyle: {
        width: "14%",
        textAlign: "center",
      },
    },
  ],
}